/**
 * Helpers para mostrar el nombre completo de un alumno o persona de forma consistente
 * y robusta (maneja casos con campos vacíos sin caer en "solo apellidos").
 */

/** Devuelve el nombre completo `Nombre ApellidoPaterno ApellidoMaterno` en una sola línea.
 *  Si el campo `nombre` está vacío, antepone un placeholder `(SIN NOMBRE)` en lugar de
 *  mostrar solo los apellidos — esto facilita detectar registros con datos incompletos
 *  en pase de lista, reportes y modales. */
export const formatNombreCompleto = (alumno) => {
  if (!alumno) return '';
  const nombre = (alumno.nombre || '').trim();
  const paterno = (alumno.apellido_paterno || '').trim();
  const materno = (alumno.apellido_materno || '').trim();
  const nombreSafe = nombre || '(SIN NOMBRE)';
  return [nombreSafe, paterno, materno].filter(Boolean).join(' ');
};

/** Devuelve el nombre en orden de apellido (Apellido Paterno Materno, Nombre).
 *  Útil para listados ordenables. */
export const formatNombreApellidoPrimero = (alumno) => {
  if (!alumno) return '';
  const nombre = (alumno.nombre || '').trim();
  const paterno = (alumno.apellido_paterno || '').trim();
  const materno = (alumno.apellido_materno || '').trim();
  const nombreSafe = nombre || '(SIN NOMBRE)';
  const apellidos = [paterno, materno].filter(Boolean).join(' ');
  return apellidos ? `${apellidos}, ${nombreSafe}` : nombreSafe;
};
